import React, { useState, useRef, useEffect } from "react";
import { FaTimes } from "react-icons/fa";

export const OtpModal = ({ isOpen, onRequestClose, onSubmit }) => {
	const [otp, setOtp] = useState(["", "", "", "", "", ""]);
	const inputsRef = useRef([]);

	const handleChange = (index, val) => {
		let value = val.replace(/\D/g, "");

		const newOtp = [...otp];
		if (value.length > 2) {
			if (value.length > otp.length) value = value.slice(-otp.length);
			for (let i = index, j = 0; i < otp.length && j < value.length; i++, j++)
				newOtp[i] = value[j];

			inputsRef.current[
				index + value.length > otp.length - 1 ? otp.length - 1 : index + value.length - 1
			].focus();
		} else if (value.length === 2) {
			newOtp[index] = otp[index] === value[1] ? value[0] : value[1];
			for (let i = index + 1; i < otp.length; i++) newOtp[i] = "";
			if (index < 5) inputsRef.current[index + 1].focus();
		} else {
			newOtp[index] = value;

			if (value !== "" && index < 5) inputsRef.current[index + 1].focus();
		}
		setOtp(newOtp);
	};

	const handleKeyDown = (index, event) => {
		if (event.key === "Backspace" && otp[index] === "" && index > 0) {
			inputsRef.current[index - 1].focus();
			// inputsRef.current[index - 1].select();
		} else if (event.key === "ArrowLeft" && index > 0) {
			inputsRef.current[index - 1].focus();
			// inputsRef.current[index - 1].select();
		} else if (event.key === "ArrowRight" && index < otp.length - 1) {
			inputsRef.current[index + 1].focus();
			// inputsRef.current[index + 1].select();
		}
	};

	const hancleCloseClick = (e) => {
		setOtp(["", "", "", "", "", ""]);
		onRequestClose(e);
	};

	useEffect(() => {
		if (otp.every((digit) => digit !== "")) {
			onSubmit(otp.join(""));
			setOtp(["", "", "", "", "", ""]); // Reset OTP
			inputsRef.current[0].focus();
		}
	}, [otp, onSubmit]);

	if (!isOpen) return null;

	return (
		<div
			className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
			style={{ zIndex: 9990 }}
		>
			<div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
				<button
					aria-label="Chiudi"
					id="close"
					onClick={hancleCloseClick}
					className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
				>
					<FaTimes size={20} />
				</button>
				<h2 className="text-lg font-semibold mb-6 text-center">Inserisci OTP</h2>
				<div className="flex justify-center gap-2">
					{otp.map((digit, index) => (
						<input
							key={index}
							id={"otp_" + index}
							type="text"
							value={digit}
							onChange={(e) => handleChange(index, e.target.value)}
							onKeyDown={(e) => handleKeyDown(index, e)}
							// onFocus={(e) => e.target.select()}
							ref={(el) => (inputsRef.current[index] = el)}
							className="w-12 h-12 text-center text-lg border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
							autoFocus={index === 0}
						/>
					))}
				</div>
			</div>
		</div>
	);
};
